import state from '.';
import { KeyMap } from '../keyboard';
import { tail } from '@vaaas/fpts/array';
import { toRaw } from 'vue';

export function change_major_mode(mode: KeyMap) {
    state.modes = [mode, ...tail(state.modes)];
}

export function activate_mode(mode: KeyMap) {
    state.modes = [...state.modes, mode];
}

export function deactivate_mode(mode: KeyMap) {
    state.modes = state.modes.filter(x => toRaw(x) !== mode);
}
